// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"5f03afc9","453":"4c927d38","796":"d53b6de2"}[chunkId] + ".chunk.js";
};